import { Dashboard } from "./components/Dashboard";
import { dashboard as reducer } from "./reducer";
import { DashboardState } from "./model";

export {
    Dashboard,
    reducer,
    DashboardState
};
